import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Footer from "../../components/Footer";

function TermsPage() {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        setIsVisible(true);
    }, []);

    return (
        <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-black">
            <div
                className="absolute inset-0 opacity-30 bg-cover bg-center scale-150"
                style={{ backgroundImage: `url(/images/sea-bg-2.jpg)` }}
            ></div>

            <div className="relative">
                <div className="max-w-4xl mx-auto px-4 pt-12 pb-12">
                    {/* Geri Dönüş Butonu */}
                    <Link
                        to="/register"
                        className="inline-flex items-center text-white/60 hover:text-white mb-8 transition-colors duration-300"
                    >
                        <svg
                            className="w-5 h-5 mr-2"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M10 19l-7-7m0 0l7-7m-7 7h18"
                            />
                        </svg>
                        Üye Ol
                    </Link>

                    <div
                        className={`bg-white/10 backdrop-blur-xl rounded-2xl p-8 shadow-xl border border-white/10 transition-all duration-700 transform ${
                            isVisible
                                ? "opacity-100 translate-y-0"
                                : "opacity-0 translate-y-12"
                        }`}
                    >
                        <h1 className="text-3xl font-bold text-white mb-8">
                            Kullanım Şartları
                        </h1>

                        <div className="space-y-8 text-white/80">
                            <section>
                                <h2 className="text-xl font-semibold text-white mb-4">
                                    1. Genel Hükümler
                                </h2>
                                <p className="leading-relaxed">
                                    Cyprus Yacht platformunu kullanarak, bu
                                    kullanım şartlarını kabul etmiş olursunuz.
                                    Platform üzerinden yapacağınız tüm
                                    işlemlerde bu şartlar geçerlidir.
                                </p>
                            </section>

                            <section>
                                <h2 className="text-xl font-semibold text-white mb-4">
                                    2. Üyelik
                                </h2>
                                <p className="leading-relaxed">
                                    Platformumuza üye olurken verdiğiniz
                                    bilgilerin doğruluğunu taahhüt etmiş
                                    olursunuz. Hesap güvenliğinizden siz
                                    sorumlusunuz.
                                </p>
                            </section>

                            <section>
                                <h2 className="text-xl font-semibold text-white mb-4">
                                    3. Rezervasyon ve Ödemeler
                                </h2>
                                <p className="leading-relaxed">
                                    Yat rezervasyonları ve ödemeler, belirtilen
                                    prosedürlere uygun şekilde yapılmalıdır.
                                    İptal ve iade koşulları her yat için ayrıca
                                    belirtilmektedir.
                                </p>
                            </section>

                            <section>
                                <h2 className="text-xl font-semibold text-white mb-4">
                                    4. Yat Sahiplerinin Sorumlulukları
                                </h2>
                                <p className="leading-relaxed">
                                    Yat sahipleri, yatlarıyla ilgili tüm
                                    bilgilerin doğruluğunu taahhüt eder ve
                                    gerekli bakım ve sigortaların yapılmasından
                                    sorumludur.
                                </p>
                            </section>

                            <section>
                                <h2 className="text-xl font-semibold text-white mb-4">
                                    5. Gizlilik
                                </h2>
                                <p className="leading-relaxed">
                                    Kişisel verileriniz, gizlilik politikamıza
                                    uygun şekilde işlenir ve korunur. Detaylı
                                    bilgi için gizlilik politikamızı
                                    inceleyebilirsiniz.
                                </p>
                            </section>

                            <section>
                                <h2 className="text-xl font-semibold text-white mb-4">
                                    6. Değişiklikler
                                </h2>
                                <p className="leading-relaxed">
                                    Cyprus Yacht, bu kullanım şartlarını önceden
                                    haber vermeksizin değiştirme hakkını saklı
                                    tutar. Güncel şartlar için bu sayfayı
                                    düzenli olarak kontrol etmenizi öneririz.
                                </p>
                            </section>
                        </div>

                        <div className="mt-8 pt-6 border-t border-white/10">
                            <p className="text-white/60 text-sm">
                                Son güncelleme:{" "}
                                {new Date().toLocaleDateString()}
                            </p>
                        </div>
                    </div>
                </div>

                <Footer />
            </div>
        </div>
    );
}

export default TermsPage;
